import gql from "graphql-tag";

export const REMOVE_APPROVAL_BY_EXAMINER = gql`
  mutation removeApprovalByExaminer($contractCode: String!) {
    removeApprovalByExaminer(contractCode: $contractCode)
  }
`;
